import React, { useState, useEffect } from "react";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../components/table/table";
import "./view.css";
import {
  get_advisorsList_list,
  admin_advisors_delete,
  get_mou_list,
  admin_mou_delete,
  get_membership_list,
  get_membership_details,
  admin_membership_delete,
} from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";

export default function View(props) {
  const [data, setData] = useState([]);
  const [view, setView] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const onSearch = () => {
    //
  };
  const handleMembershipList = async () => {
    setIsActive(true);
    try {
      const res = await get_membership_list(adminType);
      const tdata = Array.isArray(res)
        ? res.map((item, index) => ({
            ...item,
            slno: index + 1,
            from_date: item.from_date ? item.from_date : null,
            to_date: item.to_date ? item.to_date : null,
          }))
        : [];

      setData(tdata);
    } catch (error) {
      console.error("Error fetching MOU list:", error);
      setData([]);
    } finally {
      setIsActive(false);
    }
  };

  useEffect(() => {
    handleMembershipList();
  }, []);

  useEffect(() => {
    return () => {
      setData([]);
    };
  }, []);

  const handleEdit = (row) => {
    let path = `/membership-edit/${row.id}`;
    props.history.push(path);
  };

  const handleAddNew = () => {
    let path = "/membership-add";
    props.history.push(path);
  };

  const handleView = (data) => {
    let path = `/membership-view/${data.id}`;
    props.history.push(path);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };

  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_membership_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleMembershipList();
    }
  };

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  return (
    <div>
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <h6>
          <b>Memberships</b>
        </h6>
        <hr />
        {/* --------------admin----- */}
        {adminType === 1 && (
          <>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={(e) => handleAddNew(e)}
            >
              Add New
            </button>
            <CustomTable
              {...props}
              columns={[
                { title: "Sl No", field: "slno" },
                { title: "Name of Organization", field: "organization_name" },
                { title: "Membership Category", field: "membership_category" },
                {
                  title: "Start Date",
                  field: "from_date",
                  // render: (row) => {
                  //   if (row?.from_date) {
                  //     const [day, month, year] = row?.from_date.split("-");
                  //     return `${year}-${month}-${day}`;
                  //   }
                  //   return "";
                  // },
                  type: "fullDate",
                },
                {
                  title: "End Date",
                  field: "to_date",
                  // render: (row) => {
                  //   if (row?.to_date) {
                  //     const [day, month, year] = row?.to_date.split("-");
                  //     return `${year}-${month}-${day}`;
                  //   }
                  //   return "";
                  // },
                  type: "fullDate",
                },

                // { title: "Logo", field: "logo", type: "imageFull" },
                { title: "Status", field: "status", type: "mouStatus" },
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },
              ]}
            />
          </>
        )}
        {/* ----------------- */}
        {/* --------------admin----- */}
        {adminType === 2 && (
          <>
            <CustomTable
              {...props}
              columns={[
                { title: "Sl No", field: "slno" },
                { title: "Name of Organization", field: "organization_name" },
                { title: "Membership Category", field: "membership_category" },
                // { title: "Logo", field: "logo", type: "imageFull" },
                { title: "Start Date", field: "from_date", type: "fullDate" },
                { title: "End Date", field: "to_date", type: "fullDate" },
                { title: "Status", field: "status", type: "mouStatus" },
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
        {adminType === 23 && (
          <>
            <CustomTable
              {...props}
              columns={[
                { title: "Sl No", field: "slno" },
                { title: "Name of Organization", field: "organization_name" },
                { title: "Membership Category", field: "membership_category" },
                // { title: "Logo", field: "logo", type: "imageFull" },
                { title: "Start Date", field: "from_date", type: "fullDate" },
                { title: "End Date", field: "to_date", type: "fullDate" },
                { title: "Status", field: "status", type: "mouStatus" },
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Membership ?"
          data={activeData}
          message="Are you sure to delete this Membership?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
